<template>
  <img
    v-if="src"
    :src="src"
    :class="[
      'v-icon',
      `v-icon--size-${size}`,
      sizeMd && `v-icon--size-md-${sizeMd}`,
      sizeLg && `v-icon--size-lg-${sizeLg}`
    ]"
  />
</template>

<script>
const icons = {
  maternity: require("./icons/maternity.svg")
};

export default {
  props: {
    icon: {
      type: String,
      default: null
    },
    size: {
      type: Number,
      default: 1
    },
    sizeMd: {
      type: Number,
      default: null
    },
    sizeLg: {
      type: Number,
      default: null
    }
  },
  computed: {
    src() {
      return icons[this.$props.icon] || null;
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../sass/component.scss";

@mixin iconSizeClasses($breakpoint: null) {
  @for $index from 1 through 5 {
    &--size#{if($breakpoint, '-' + $breakpoint, '')}-#{$index} {
      width: #{20 + ($index * 20)}px;
    }
  }
}

.v-icon {
  // Size classes for small and up
  @include iconSizeClasses();

  // Size classes for medium and up
  @include media-breakpoint-up(md) {
    @include iconSizeClasses(md);
  }

  // Size classes for large and up
  @include media-breakpoint-up(lg) {
    @include iconSizeClasses(lg);
  }
}
</style>
